import { Link, useNavigate, useParams } from "react-router-dom"
import { Customerinfo, Footer, Header } from "../Components"
// import pdf from '../assets/ticket_111.pdf'
import { FaHome, FaSync } from "react-icons/fa"
import { useEffect, useState } from "react"
import { Api } from "../Constants"
import { toast } from "react-toastify"
import { MdRotateRight, MdSync } from "react-icons/md"
const PDF = () => {
    const [custId, setCustId] = useState()
    const [pdfLink, setPdfLink] = useState()
    const [totalTickets, setTotalTickets] = useState()
    const [customer, setCustomer] = useState({})
    const [tableData, settableData] = useState([])
    const [footData, setfootData] = useState({ subTotal: null, discount: null, taxable: null, vat: null, total: null })
    const params = useParams();
    let navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            // Fetch PDF data
            const pdfRes = await Api.postCustomerTicket(params.id);
            console.log('pdfres', pdfRes.status)
            if (pdfRes.status == true) {
                setPdfLink(pdfRes.data.ticket_pdf);
                const customer_id = pdfRes.data.customer_id;

                const ordersRes = await Api.getOrders(customer_id);
                if (ordersRes.status) {
                    setCustomer(ordersRes.data.Customer);
                    let customer_ticket = ordersRes.data.tickets[0].customer_ticket;
                    settableData(customer_ticket);
                    setTotalTickets(customer_ticket.length);
        
                    let subTotal = 0;
                    let discount = 0;
                    let taxable = 0;
                    let vat = 0;
                    let total_amount = 0;
        
                    customer_ticket.forEach(element => {
                        subTotal += parseFloat(element.amount);
                        discount += parseFloat(element.discount);
                        taxable += parseFloat(element.taxable_amount);
                        vat += parseFloat(element.vat_amount);
                        total_amount += parseFloat(element.total_amount);
                    });
        
                    setfootData({
                        subTotal: subTotal.toFixed(2),
                        discount: discount.toFixed(2),
                        taxable: taxable.toFixed(2),
                        vat: vat.toFixed(2),
                        total: total_amount.toFixed(2),
                    });
                } else {
                    if (!toast.isActive('1')) {
                        toast.error('Failed to load data.');
                    }
                    // navigate("/");
                }
            } else if (pdfRes.status == 404) {
                const customer_id = pdfRes.data.customer_id;
                const ordersRes = await Api.getOrders(customer_id);
                if (ordersRes.status) {
                    setCustomer(ordersRes.data.Customer);
                    let customer_ticket = ordersRes.data.tickets[0].customer_ticket;
                    settableData(customer_ticket);
                    setTotalTickets(customer_ticket.length);
        
                    let subTotal = 0;
                    let discount = 0;
                    let taxable = 0;
                    let vat = 0;
                    let total_amount = 0;
        
                    customer_ticket.forEach(element => {
                        subTotal += parseFloat(element.amount);
                        discount += parseFloat(element.discount);
                        taxable += parseFloat(element.taxable_amount);
                        vat += parseFloat(element.vat_amount);
                        total_amount += parseFloat(element.total_amount);
                    });
        
                    setfootData({
                        subTotal: subTotal.toFixed(2),
                        discount: discount.toFixed(2),
                        taxable: taxable.toFixed(2),
                        vat: vat.toFixed(2),
                        total: total_amount.toFixed(2),
                    });
                } else {
                    if (!toast.isActive('1')) {
                        toast.error('Failed to load data.');
                    }
                    // navigate("/");
                }
                // if (!toast.isActive('1')) {
                //     toast.error('Failed to fetch ticket.');
                // }
            } else if (pdfRes.status == 400 || pdfRes.status == 500) {
                if (!toast.isActive('1')) {
                    toast.error('Failed to fetch ticket');
                }
                navigate("/");
            }
        };
    
        fetchData();
    }, [params.id]); 
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                const link = document.createElement('a');
                link.href = pdfLink;
                link.download = 'ticket.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        };
        if (pdfLink != undefined) {
        handleResize();
        }
    }, [pdfLink]);
    return (
        <>
            <Header />
            <div className="sm-section-container">
                <div className="container">
                    <div className="row pt-4">
                        <div className="col-lg-12">
                            <div className="row align-items-center mb-2">
                                <h5 className="col-md-6 main-title2 display-6 text-uppercase text-center text-md-start mb-0">
                                    Ticket Details
                                </h5>
                                <div className="col-md-6 d-md-flex d-none justify-content-md-end justify-content-start">
                                    <Link to={'/'}>
                                        <button className='btn btn-primary' title='Go Back To Homepage'>
                                            <FaHome />
                                        </button>
                                    </Link>
                                    {/* <a className="btn btn-primary" href={pdfLink} download={`${customer.id}.pdf`}>
                                        Download PDF
                                    </a> */}
                                </div>
                                <small className="mt-md-1 my-md-0 my-2 small-text">
                                    Please arrive at boarding hall to enjoy your ride. Please note that your ticket will be valid for 7 days.
                                </small>
                                <div className={`col-md-6 d-md-none d-flex mt-2 ${pdfLink ? 'justify-content-between' : 'justify-content-end'}`}>
                                    <Link to={'/'}>
                                        <button className='btn btn-primary ' title='Go Back To Homepage'>
                                            <FaHome />
                                        </button>
                                    </Link>
                                    {pdfLink ? 
                                        <>
                                        <a className="btn btn-primary" href={pdfLink} download={`${customer.id}.pdf`}>
                                            Download your ticket
                                        </a>
                                        </> : ''
                                    }
                                </div>
                                {!pdfLink && 
                                    <div className="col-12">
                                        <div className="d-flex d-md-none justify-content-center flex-column loading-bg py-3 mt-3 px-2">
                                            <h6 className="text-center"><span>
                                                    <div className="spinner-grow" style={{width: '1.2rem', height:'1.2rem'}}>
                                                    </div>
                                                </span> Your ticket is being processed, please try again after a few minutes !
                                            </h6>
                                            <div className="d-flex justify-content-center">
                                                <div className="btn btn-primary" onClick={()=> {
                                                    window.location.reload();
                                                }}>
                                                    Try Again
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-lg-8 d-none d-md-block">
                            {pdfLink ? 
                            <iframe
                            src={pdfLink}
                            width="100%"
                            height="450px"
                            title="PDF Viewer"
                            style={{ border: 'none' }}
                            /> : <>
                            <div className="d-flex justify-content-center flex-column py-3 loading-bg">
                                <h6 className="text-center"><span>
                                        <div className="spinner-grow" style={{width: '1.2rem', height:'1.2rem'}}>
                                        </div>
                                    </span> Your ticket is being processed, please try again after a few minutes !
                                </h6>
                                <div className="d-flex justify-content-center">
                                    <div className="btn btn-primary" onClick={()=> {
                                        window.location.reload();
                                    }}>
                                        Try Again
                                    </div>
                                </div>
                            </div>
                            </> }
                            
                        </div>
                        {/* <div className="col-lg-8 d-flex d-md-none justify-content-end">
                            <a className="btn btn-primary" href={pdfLink} download={`${customer.id}.pdf`}>
                                Download your ticket
                            </a> 
                        </div> */}
                        <div className="col-lg-4 my-2 my-lg-0 pb-md-0 pb-5">
                            <Customerinfo customer={customer} footData={footData} quantity={totalTickets}/>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}
export default PDF